import { render, staticRenderFns } from "./UsersManagement.vue?vue&type=template&id=c3d981b6&scoped=true"
import script from "./UsersManagement.vue?vue&type=script&lang=ts"
export * from "./UsersManagement.vue?vue&type=script&lang=ts"
import style0 from "./UsersManagement.vue?vue&type=style&index=0&id=c3d981b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d981b6",
  null
  
)

export default component.exports